/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useEffect, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  Keyboard,
  Navigation,
  Pagination,
  FreeMode,
} from "swiper";

import "swiper/swiper-bundle.min.css";
import { carouselEducacaoInfantilSwipe } from "../assets/styles/Slider.styles";

import ImgEF1 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-1.png'
import ImgEF2 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-2.png'
import ImgEF3 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-3.png'
import ImgEF4 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-4.png'
import ImgEF5 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-5.png'
import ImgEF6 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-6.png'
import ImgEF7 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-7.png'
import ImgEF8 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-8.png'
import ImgEF9 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-9.png'
import ImgEF10 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-10.png'
import ImgEF11 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-11.png'
import ImgEF12 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-12.png'
import ImgEF13 from '../assets/images/LP-arabe/img-educacao-fundamental/img-ef-13.png'

SwiperCore.use([Pagination, Autoplay, Keyboard, Navigation, FreeMode]);

const SliderHome = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (src) => {
    setSelectedImage(src);
    setModalShow(true);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    if (typeof window !== "undefined") {
      setIsMobile(window.innerWidth < 600);
      window.addEventListener("resize", handleResize);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  const images = [
    ImgEF1,
    ImgEF2,
    ImgEF3,
    ImgEF4,
    ImgEF5,
    ImgEF6,
    ImgEF7,
    ImgEF8,
    ImgEF9,
    ImgEF10,
    ImgEF11,
    ImgEF12,
    ImgEF13,
  ];

  return (
    <section
      style={{ position: "relative", overflow: "hidden", paddingBottom: 0 }}
      css={carouselEducacaoInfantilSwipe}
    >
      <Container>
        <Row className="pb-5 pt-5">
          <Col
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-easing="ease-in-sine"
            md={12}
            className="slideCarrousel order-1 order-md-2"
          >
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={isMobile ? 0 : 16}
              loop={true}
              freeMode={true}
              keyboard={{ enabled: true }}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              speed={8000}
              mousewheel={true}
              modules={[Autoplay, Keyboard, Pagination, Navigation, FreeMode]}
              className="mySwiper"
            >
              {images.map((src, i) => (
                <SwiperSlide key={i} style={{ width: "300px" }}>
                  <div>
                    <img
                      className="img-estrutura"
                      src={src}
                      alt={`estrutura-${i}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleImageClick(src)}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>

      {/* Modal de visualização da imagem ampliada */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        centered
        size="lg"
        contentClassName="bg-transparent border-0 shadow-none"
      >
        <Modal.Body
          style={{
            padding: 0,
            textAlign: "center",
            backgroundColor: "transparent",
          }}
        >
          <img
            src={selectedImage}
            alt="ampliado"
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "600px",
              objectFit: "contain",
            }}
          />
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default SliderHome;
